import { render, staticRenderFns } from "./OffersRevamp.vue?vue&type=template&id=68b59479"
import script from "./OffersRevamp.vue?vue&type=script&lang=js"
export * from "./OffersRevamp.vue?vue&type=script&lang=js"
import style0 from "./OffersRevamp.vue?vue&type=style&index=0&id=68b59479&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports